import { apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const newsBadgesApi = {
  createArticle: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>("/news", body),

  listArticles: (params?: PaginatedParams & { category?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.category) searchParams.set("category", params.category);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/news?${searchParams.toString()}`);
  },

  getArticle: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/news/${id}`),

  deleteArticle: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/news/${id}`),

  markAsRead: (id: string) => apiPost<{ data: Record<string, unknown> }>(`/news/${id}/read`),

  getReputation: () => apiGet<{ data: Record<string, unknown> }>("/reputation"),
};
